import { mapState, mapActions } from 'vuex';
import reportStatus from 'enums/report-status';

export default {
  computed: {
    ...mapState("labcorp", ["labcorp"]),
    ...mapState("report", ["report"]),

    isAdvancedReport() { return this.report.type.includes('Advanced') },
    isCraReport() { return this.report.type.includes('Cardiometabolic') },
    isApoBReport() { return this.report.type.includes('APO B') },
    isHomaIRReport() { return this.report.type.includes('HOMA-IR') },
    reportId() { return this.$route.params.id },
    onlyView() { return this.report.status == reportStatus.Completed || this.report.assigneeId != this.$auth.id || this.report.status == reportStatus.WaitingSurvey }
  },

  methods: {
    ...mapActions("labcorp", ["generateFinalReport", "resetLabcorpDataToDefault", "getLabcorpResult"]),
    ...mapActions("report", ["getById", "updateReport"]),

    async onSubmit() {
      this.labcorp.patientId = this.report.patientId;
      this.labcorp.reportId = this.report.id;

      const updatedReport = await this.generateFinalReport();
      this.updateReport(updatedReport);
      this.$root.successToast("Final report generated!");
    }
  },

  async created() {
    this.resetLabcorpDataToDefault();
    await this.getLabcorpResult(this.reportId);
    await this.getById(this.reportId);
  }
}